<template>
	<roi-container>
		<template slot="header">
			Savings Potential
		</template>
		
		<template slot="content">
			<v-sheet v-if="monthlySavings > 0" color="primary darken-2">
				<v-sparkline
					:value="value"
					color="rgba(255, 255, 255, 1)"
					class="chart"
					height="130"
					width="300"
					line-width="4"
					stroke-linecap="butt"
					auto-draw
					padding="25">
						<template
						slot="label"
						slot-scope="item"
						>
							{{ $parent.formatter.format(item.value) }}
						</template>
				</v-sparkline>
			</v-sheet>

			<v-card-text>
				<div v-if="monthlySavings > 0" class="white--text text-xs-center">
					<p>DataSelf reduces labor-intensive reporting-tasks by 80% or more. With an average savings of <strong>{{ this.$parent.formatter.format(this.monthlySavings) }}</strong> on automation alone using our <em><strong>QuickStart Package</strong></em>, your bottom line will see an increase of <strong>{{ this.$parent.formatter.format(this.monthlySavings) }}</strong> every month.</p>
				</div>
				<div v-else class="white--text text-xs-center">
					<p>DataSelf reduces labor-intensive reporting-tasks by 80% or more. Starting out, you will save an estimated <strong>{{ this.$parent.formatter.format(this.monthlySavings + parseInt($parent.getSmartPackagePrice, 10)) }}</strong> per month gross on automation with our <em><strong>QuickStart Package</strong></em>. Additionally, you will have access to thousands of templates to give you insights into your business.</p>
				</div>
				<div v-if="monthlySavings > 0" class="white--text text-xs-center">
					<span class="display-1">{{ totalSavings }}</span>
					<br>
					<small style="font-size: 15px" class="">over {{ this.months }} months</small>
				</div>
			</v-card-text>

		</template>
		
		<template slot="button">
			<v-layout row mt-4 align-center justify-center>
				<v-btn @click="$parent.goToPage()" color="primary darken-2" ripple large>Get Started</v-btn>
			</v-layout>
			<v-layout row mt-0 align-center justify-center>
				<v-btn 
					@click="$parent.component = 'RoiCalc'" 
					class="go-back-btn"
					flat 
					color="primary darken-2"
					small>Back</v-btn>
			</v-layout>
		</template>
	</roi-container>
</template>

<script>
import RoiContainer from './RoiContainer.vue'

export default {
	components: {
		RoiContainer
	},
	props: {
		monthlySavings: {
			type: [Number],
			default: 500
		}
	},
	data() {
		return {
			months: 12,
			value: []
		}
	},
	computed: {
		totalSavings() {
			return this.$parent.formatter.format(this.monthlySavings * this.months)
		},
		totalSavingsRaw() {
			return this.monthlySavings * this.months
		}
	},
	created() {
		// [...Array(this.months - 1)].forEach((_, i) => {
		// 	let max = this.monthlySavings * (i + 1)
		// 	let min = this.value.slice(-1).pop()
		// 	min = min ? min : 0 // first iteration
		// 	min = min < (max / 2) ? Math.floor(max / 2.2) : min // min is too low

		// 	let randomNum = Math.floor(Math.random() * (max - min + 1)) + min

		// 	this.value.push(randomNum)
		// })
		
		// this.value.push(this.monthlySavings * this.months)

		// Update after the fact to just have the start and end
		this.value.push(this.monthlySavings)
		this.value.push(this.monthlySavings * this.months)

	},
	methods: {}
}
</script>

<style>
/* svg.chart text {
    display: none;
}
svg.chart text:first-of-type,
svg.chart text:last-of-type {
    display: block;
} */
.go-back-btn:hover {
	background: none;
}
</style>
